var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-3 py-2"},[_c('fdw-odds-comparison',{attrs:{"client":"114","league":"nba"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }